import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

export const toggleVariants = cva(
  'inline-flex min-h-10 items-center justify-center gap-2 rounded-full px-4 text-sm font-medium transition-all duration-300 ease-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-95 data-[state=on]:shadow-sm',
  {
    variants: {
      variant: {
        default: 'bg-transparent hover:bg-muted data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
        outline: 'border border-input bg-transparent hover:bg-accent data-[state=on]:border-transparent data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
      },
      size: { default: 'h-10 px-4', sm: 'h-9 px-3', lg: 'h-12 px-5' },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  }
);

export function Toggle({ className, variant, size, ...props }) {
  return <TogglePrimitive.Root data-slot="toggle" className={cn(toggleVariants({ variant, size, className }))} {...props} />;
}
